import React, {useState} from 'react';
import {Form, Icon, Input, Button} from 'antd';
import {FormattedMessage, injectIntl} from 'react-intl';

type LoginProps = {
  login: (data: object) => void,
  onLoginSuccess: () => void
  
}

const LoginForm: React.FC<LoginProps> = props => {
  const {form, intl, login, onLoginSuccess} = props;
  const {formatMessage} = intl;
  const {getFieldDecorator} = form;
  
  const [request, setRequest] = useState({
    loading: false,
    error: false
  });
  
  const showError = error => {
    setRequest({
      loading: false,
      error: true
    });
  };
  
  const handleSubmit = e => {
    e.preventDefault();
    if (request.loading) {
      return
    }
    form.validateFields((err, values) => {
      if (!err) {
        setRequest({
          loading: true,
          error: false
        });
        
        login({
          payload: values,
          onErrorCallback: showError,
          onSuccessCallback: onLoginSuccess
        })
      }
    });
  };
  
  return (
    <Form onSubmit={handleSubmit} className="login-form">
      <div><h2 className={`form-title`}><FormattedMessage id="app.login_users" defaultMessage={`Login Users`}/>
      </h2></div>
      
      <Form.Item>
        {getFieldDecorator('username', {
          rules: [{
            whitespace: true,
            required: true,
            message: <FormattedMessage id="app.enter_username"
                                       defaultMessage={`Please input your username!`}/>
          }],
        })(
          <Input
            size={`large`}
            prefix={<Icon type="user" style={{color: 'rgba(0,0,0,.25)'}}/>}
            placeholder={
              formatMessage({
                id: "app.username",
                defaultMessage: "Username",
              })}
          />,
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('password', {
          rules: [{
            whitespace: true,
            required: true,
            message: <FormattedMessage id="app.enter_password"
                                       defaultMessage={`Please input your password!`}/>
          }],
        })(
          <Input
            prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
            type="password"
            size={`large`}
            placeholder={
              formatMessage({
                id: "app.password",
                defaultMessage: "Password",
              })}
          />
        )}
      </Form.Item>
      <Form.Item>
        <Button size={`large`} type="primary" htmlType="submit" className="login-form-button"
                loading={request.loading}>
          <FormattedMessage id="app.login" defaultMessage={`Login`}/>
        </Button>
      </Form.Item>
      
      {/*//Show Error Message*/}
      {request.error && (
        <div><p className={`error-message`}><FormattedMessage id="app.username_password_is_wrong"
                                                              defaultMessage={`Username or password is not correct!`}/>
        </p></div>
      )}
    
    </Form>
  );
};

export default Form.create({name: 'login_login'})(injectIntl(LoginForm));